import angular from 'angular';
import './clientsServices';

/**
 * @ngdoc overview
 * @name superuserModule.clientsControllers
 * @description
 * # superuserModule.clientsControllers
 * Module for managing the controllers of: clients.
 */
const clientsControllers = angular.module('superuserModule.clientsControllers', ['superuserModule.clientsServices']);

/**
 * @ngdoc controller
 * @name superuserModule.clientsControllers.controller:ClientsListController
 * @description
 * Controller for the list of clients
 */
clientsControllers.controller('ClientsListController', ['$scope', 'NgTableParams', 'Client', 'growl', 'AppsoupAPI', function ($scope, NgTableParams, Client, growl, AppsoupAPI) {
    'use strict';

    $scope.search = {};
    $scope.check = false;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Client.getList(params && params._params ? params._params : {})
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeClient = function (id, index) {
        Client.remove(id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.CLIENTS.SUCCESS.DELETE_CLIENT');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.CLIENTS.ERROR.DELETE');
                }
            });
    };

    $scope.searchClients = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        if (angular.isDefined($scope.tableParams._params.email)) {
            $scope.tableParams._params.email = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

/**
 * @ngdoc controller
 * @name superuserModule.clientsControllers.controller:ClientPageController
 * @description
 * Controller for the specific client page
 */
clientsControllers.controller('ClientPageController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Client', 'UserForm', 'Package', '$filter', function ($scope, $rootScope, $state, $stateParams, growl, Client, UserForm, Package, $filter) {
    'use strict';

    const clientId = $stateParams.clientId;
    $scope.client = {user_limit: 1};

    if (angular.isDefined(clientId)) {
        $scope.editMode = true;
        $rootScope.doingResolve = true;
        Client.get(clientId)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $scope.packages = data.packages;
                    $scope.client = data.client;
                    if ($scope.client.permission_package_id === null) {
                        $scope.client.permission_package_id = $scope.packages[0].id;
                    }
                    $scope.selected = Client.convertClientPermissions(data.client.permissions);
                    $scope.applications = data.client.permissions.app || [];
                } else {
                    growl.error('MODULES.CLIENTS.' + data.error);
                }
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    } else {
        $scope.selected = {places: [], levels: [], areas: [], zones: [], beacons: []};
        $scope.applications = [];
        $scope.getPackage = true;

        Package.getList()
            .then(function (response) {
                $scope.packages = response;
                $scope.client.permission_package_id = response[0].id;

                return UserForm.getForm();
            })
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $scope.roles = data.roles;
                }
                $scope.getPackage = false;
            });
    }

    $scope.buTypes = [];

    $scope.changeTypes = function () {
        if (angular.isDefined($scope.client.bu_types)) {
            const tempTypes = [];
            angular.forEach($scope.client.bu_types, function (value) {
                value = $filter('removeSpecial')(value);
                value = $filter('changeSpecial')(value);
                value = $filter('lowercase')(value);
                if (angular.isDefined(value) && tempTypes.indexOf(value) === -1) {
                    tempTypes.push(value);
                }
            });
            $scope.client.bu_types = tempTypes;
        }
    };

    $scope.increaseLimit = function () {
        $scope.client.user_limit++;
    };

    $scope.decreaseLimit = function () {
        if ($scope.client.user_limit > 0) {
            $scope.client.user_limit--;
        }
    };

    $scope.saveClient = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.clientForm.$valid) {
            $scope.isLoading = true;
            $scope.client.permissions = Client.prepareClientPermissions($scope.selected, $scope.applications);

            if (angular.isDefined($scope.client.bu_types)) {
                const types = [];

                angular.forEach($scope.client.bu_types, function (value) {
                    value = $filter('removeSpecial')(value);
                    value = $filter('changeSpecial')(value);
                    value = $filter('lowercase')(value);
                    if (angular.isDefined(value)) {
                        types.push(value);
                    }
                });

                $scope.client.bu_types = types;
            }

            Client.save($scope.client, $scope.editMode, $scope.admin, $scope.place)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        growl.success('MODULES.CLIENTS.SUCCESS.' + ($scope.editMode ? 'EDIT_CLIENT' : 'NEW_CLIENT'));
                        $state.go('appsoup.admin.clients');
                    } else {
                        $scope.formErrors = data.errors;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.$watch('client.bu', function () {
        if ($scope.client.bu) {
            let tmp = angular.copy($scope.client.bu);
            tmp = $filter('removeSpecial')(tmp);
            tmp = $filter('changeSpecial')(tmp);
            tmp = $filter('lowercase')(tmp);
            $scope.client.bu = tmp;
        }
    });

    $scope.cancel = function () {
        $state.go('appsoup.admin.clients');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
        'email': [{error: 'required', msg: 'ERROR.REQUIRE.EMAIL'}, {error: 'email', msg: 'ERROR.INVALID.EMAIL'}],
        'phone': [{error: 'pattern', msg: 'ERROR.PATTERN.PHONE'}],
        'user_limit': [{type: '$invalid', msg: 'FORM.ERRORS.FORMAT'}]
    };

    $scope.inputUserErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}],
        'email': [{error: 'required', msg: 'ERROR.REQUIRE.EMAIL'}, {error: 'email', msg: 'ERROR.INVALID.EMAIL'}]
    };
}]);

export default clientsControllers;
